<template>
	<LayoutOffcanvasStandard ref="offcanvas" :title="(selecteds.quantity == 1) ? 'Asignar cliente' : `Asignar los ${selecteds.quantity} clientes`" id="company-admin-customer-assign">
		<template #body>
			<ul class="list-group list-group-flush rounded-4">
				<template v-if="users.length > 0">
					<li class="list-group-item px-0 py-3 lh-sm hstack gap-1" v-for="user in users" :key="user.id">
						<div class="vstack">
							<a href="javascript:void(0);" class="fw-bold link-dark stretched-link" @click="submit(user.id);">{{ user.name }}</a>
							<small class="d-block fw-normal">{{ (user.customers_count == 0) ? 'Sin clientes asignados' : ((user.customers_count == 0) ? '1 cliente asignado' : `${user.customers_count} clientes asignados`) }}</small>
						</div>
						<i class="bi bi-chevron-right text-xl"></i>
					</li>
				</template>
				<template v-else>
					<li class="list-group-item px-0 py-3 lh-sm">
						No se encontraron vendedores.
					</li>
				</template>
			</ul>
			<CommonMessageInfo info="Selecciona al vendedor para asignar los clientes." />
		</template>
		<template #footer>
			<button type="button" class="btn rounded-pill btn-danger" :disabled="submitting" @click="unassign">Desasignar clientes</button>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref } from 'vue';
	import _ from 'lodash';
	import composableForm from '@/composables/form';
	import CompanyAdminUserRepository from '@/repositories/modules/Company/Admin/User';
	import CompanyLeaderCustomerRepository from '@/repositories/modules/Company/Leader/Customer';

	export default {
		emits: ['unselect', 'reload'],
		props: {
			selecteds: Object,
			filters: Object
		},
		setup(props, { emit }) {
			const { submitting, catchError } = composableForm();
			const offcanvas = ref(null);
			const users = ref([]);

			const unselect = async () => {
				emit('unselect');
				offcanvas.value.offcanvas.hide();
			}

			const submit = async (id) => {
				if(submitting.value) return;
				submitting.value = true;

				var data = _.clone(props.filters);
				data.selection = {
					selecteds: props.selecteds,
					user_id: id
				}

				await CompanyLeaderCustomerRepository.assign(data).then(finish).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const unassign = async (id) => {
				if(submitting.value) return;
				submitting.value = true;

				var data = _.clone(props.filters);
				data.selection = {
					selecteds: props.selecteds,
					user_id: id
				}

				await CompanyLeaderCustomerRepository.unassign(data).then(finish).catch((e) => catchError(e, true));

				submitting.value = false;
			}

			const finish = () => {
				emit('unselect');
				emit('reload');
				offcanvas.value.offcanvas.hide();
			}

			const show = async () => {
				await CompanyAdminUserRepository.list({ role: 'seller' }).then((response) => {
					users.value = response.data;
				}).catch((e) => catchError(e, true));

				offcanvas.value.offcanvas.show();
			}

			return { offcanvas, users, unselect, submit, unassign, show, submitting };
		}
	}
</script>